import type { AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'

import { agencyCategoryList } from '@/components/agencies/agency-form.schema'

/**
 * Filters a list of free-form category strings from the API
 * to only include categories known by the frontend.
 */
export const filterKnownCategoryList = (categoryList: string[]): AgencyCategory[] =>
  categoryList.filter((c): c is AgencyCategory =>
    (agencyCategoryList as readonly string[]).includes(c)
  )
